import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { NitroModule } from 'src/app/nitro/nitro.module';
import { MaterialModule } from 'src/app/nitro/utils/material-components.module';

import { ToolbarComponent } from './toolbar/toolbar.component';
import { ToolbarUserComponent } from './toolbar/toolbar-user/toolbar-user.component';
import { ToolbarSearchComponent } from './toolbar/toolbar-search/toolbar-search.component';
import { ToolbarFullscreenToggleComponent } from './toolbar/toolbar-fullscreen-toggle/toolbar-fullscreen-toggle.component';
import { ToolbarSidenavMobileToggleComponent } from './toolbar/toolbar-sidenav-mobile-toggle/toolbar-sidenav-mobile-toggle.component';
import { SidenavService } from 'src/app/services/sidenav.service';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SidenavItemComponent } from './sidenav/sidenav-item/sidenav-item.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LoadingMainScreemComponent } from './loading-main-screem/loading-main-screem.component';
import { SidenavItemRevolutionComponent } from './sidenav/sidenav-item-revolution/sidenav-item-revolution.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NitroModule,
    MaterialModule,
    FlexLayoutModule
  ],
  declarations: [
    LayoutComponent,
    SidenavComponent,
    SidenavItemComponent,
    ToolbarComponent,
    ToolbarUserComponent,
    ToolbarSearchComponent,
    ToolbarFullscreenToggleComponent,
    ToolbarSidenavMobileToggleComponent,
    LoadingMainScreemComponent,
    SidenavItemRevolutionComponent
  ],
  providers: [SidenavService]
})
export class LayoutModule { }
